// Site Configuration - Edit all content and settings here
export const siteConfig = {
  // Brand Info
  brand: {
    name: "Casa de Candy",
    tagline: "Premium Companionship Experience",
    description: "Beauty + Discipline + Safety + Controlled Environment",
    domain: "casadecandy.com",
    email: "deydey110802@gmail.com",
    established: "Est. 2024",
    // Logo - transparent background version
    logoUrl: "/logo.png",
  },

  // Contact Information
  contact: {
    phone: "956-476-6969",
    phoneClean: "19564766969",
    whatsappLink: "https://wa.me/19568054936",
  },

  // Location
  location: {
    area: "Rio Grande Valley",
    address: "Near Mile 15 and Texas Blvd",
    city: "Weslaco",
    state: "Texas",
    zip: "78599",
    fullAddress: "Near Mile 15 and Texas Blvd, Weslaco, TX",
    note: "Exact location details are shared after confirmation to maintain privacy and discretion.",
    mapsLink: "https://www.google.com/maps/place/Weslaco,+TX/@26.1595,-97.9906,14z",
  },

  // Animations (local files for reliable playback)
  animations: {
    hub: "/animation1.mp4",
    page: "/animation2.mp4",
  },

  // Pricing Structure
  pricing: {
    inCall: {
      label: "In-Call",
      note: "No deposit required",
      services: [
        { code: "QV", name: "Quick Visit", duration: "15 min", price: 160 },
        { code: "HH", name: "Half Hour", duration: "30 min", price: 240 },
        { code: "HR", name: "Full Hour", duration: "60 min", price: 360 },
      ],
    },
    outCall: {
      label: "Out-Call",
      note: "$75 deposit required",
      surcharge: 90,
      deposit: 75,
      services: [
        { code: "QV", name: "Quick Visit", duration: "15 min", price: 250 },
        { code: "HH", name: "Half Hour", duration: "30 min", price: 330 },
        { code: "HR", name: "Full Hour", duration: "60 min", price: 450 },
      ],
    },
  },

  // Navigation Links
  nav: {
    en: [
      { label: "Overview", href: "#about" },
      { label: "Rates", href: "#rates" },
      { label: "Experience", href: "#experience" },
      { label: "Location", href: "#location" },
      { label: "Book", href: "#book" },
    ],
    es: [
      { label: "Resumen", href: "#about" },
      { label: "Tarifas", href: "#rates" },
      { label: "Experiencia", href: "#experience" },
      { label: "Ubicación", href: "#location" },
      { label: "Reservar", href: "#book" },
    ],
  },

  // Legal Service Framing
  legalDescription: {
    en: "Casa de Candy operates legally as a companionship service. We provide time, environment, and presence within a curated experience.",
    es: "Casa de Candy opera legalmente como un servicio de compañía. Proporcionamos tiempo, ambiente y presencia dentro de una experiencia curada.",
  },

  // Content Translations
  content: {
    en: {
      hero: {
        title: "Casa de Candy",
        subtitle: "Premium Companionship Experience",
        description: "Curated experiences with exclusivity, professionalism, and discretion. Elegance and warmth — designed for the discerning gentleman.",
      },
      about: {
        title: "Experience & Atmosphere",
        subtitle: "What We Offer",
        description: "Casa de Candy is set up as a private studio-style space in Weslaco — designed for clients who care about presentation, discretion, and a chill vibe. This is for clients who want something better than the usual chaos — a fixed place, a real team, and a consistent energy.",
        features: [
          "Clean bedroom layout with neon-lit aesthetic",
          "Shower available before or after — no rush",
          "Small lounge area to break the ice and relax",
          "Cold refreshments available upon request",
        ],
      },
      howItWorks: {
        title: "How Booking Works",
        subtitle: "Simple & Discreet",
        steps: [
          { step: "01", title: "Message Us", description: "Send your preferred time, session length, and whether you want in-call or out-call" },
          { step: "02", title: "Confirm", description: "Once confirmed, you'll get simple directions, arrival instructions, and any details needed" },
          { step: "03", title: "Arrive", description: "When you're near, send a quick 'here' text so we can bring you in smoothly" },
        ],
      },
      rates: {
        title: "Session Rates",
        subtitle: "Transparent Pricing",
        inCallTab: "In-Call",
        outCallTab: "Out-Call (+$90)",
        depositNote: "$75 deposit required for out-call to confirm scheduling",
        noDeposit: "No deposit required for in-calls",
      },
      boundaries: {
        title: "Expectations & Boundaries",
        subtitle: "House Rules",
        rules: [
          "Be on time or let us know if you're running late",
          "Arrive clean or take advantage of the shower — no rush",
          "Come with good energy and basic respect",
          "Anything aggressive, reckless, or out of bounds ends the session immediately",
          "We're about long-term clients, not quick chaos",
        ],
      },
      booking: {
        title: "Request a Session",
        subtitle: "Schedule Your Experience",
        form: {
          name: "Name / Alias",
          contact: "Contact Method",
          phone: "Phone / WhatsApp",
          date: "Preferred Date & Time",
          service: "Service Length",
          type: "Session Type",
          notes: "Additional Notes",
          submit: "Send Request",
          inCall: "In-Call",
          outCall: "Out-Call",
        },
        success: {
          title: "Request Sent!",
          message: "We'll contact you shortly to confirm your session.",
        },
      },
      faq: {
        title: "FAQ",
        subtitle: "Common Questions",
        items: [
          {
            question: "How do I schedule a session?",
            answer: "Contact us via call, text, WhatsApp, or email to discuss availability. Once a time is confirmed, we will provide any additional details needed.",
          },
          {
            question: "How is payment handled?",
            answer: "Payment for reserved time is accepted at the beginning of each session. For out-call appointments, a deposit may be required to confirm scheduling.",
          },
          {
            question: "Can I request a specific companion?",
            answer: "Yes, subject to availability. Contact us with your preferences and we will do our best to accommodate your scheduling request.",
          },
          {
            question: "What is the cancellation policy?",
            answer: "Please provide at least 2 hours notice for any scheduling changes. Deposits for confirmed appointments are non-refundable for no-shows or last-minute cancellations.",
          },
        ],
      },
      location: {
        title: "Service Area",
        subtitle: "Where We Are",
      },
      footer: {
        disclaimer: "This site is intended for adults 18+ only. By using this site, you confirm you are of legal age.",
        copyright: "Casa de Candy",
      },
    },
    es: {
      hero: {
        title: "Casa de Candy",
        subtitle: "Experiencia de Compañía Premium",
        description: "Experiencias curadas con exclusividad, profesionalismo y discreción. Elegancia y calidez — diseñadas para el caballero exigente.",
      },
      about: {
        title: "Experiencia y Ambiente",
        subtitle: "Lo Que Ofrecemos",
        description: "Casa de Candy es un espacio privado estilo estudio en Weslaco — diseñado para clientes que valoran la presentación, discreción y un ambiente relajado. Esto es para clientes que quieren algo mejor que el caos usual — un lugar fijo, un equipo real y energía consistente.",
        features: [
          "Habitación limpia con estética neón",
          "Ducha disponible antes o después — sin prisa",
          "Área lounge para relajarse",
          "Bebidas frías disponibles",
        ],
      },
      howItWorks: {
        title: "Cómo Reservar",
        subtitle: "Simple y Discreto",
        steps: [
          { step: "01", title: "Escríbenos", description: "Envía tu hora preferida, duración de sesión, y si quieres in-call o out-call" },
          { step: "02", title: "Confirma", description: "Una vez confirmado, recibirás direcciones simples e instrucciones de llegada" },
          { step: "03", title: "Llega", description: "Cuando estés cerca, envía un mensaje 'aquí' para recibirte" },
        ],
      },
      rates: {
        title: "Tarifas de Sesión",
        subtitle: "Precios Transparentes",
        inCallTab: "En Casa",
        outCallTab: "A Domicilio (+$90)",
        depositNote: "Se requiere depósito de $75 para confirmar citas a domicilio",
        noDeposit: "No se requiere depósito para citas en casa",
      },
      boundaries: {
        title: "Expectativas y Límites",
        subtitle: "Reglas de Casa",
        rules: [
          "Llega a tiempo o avísanos si vas tarde",
          "Llega limpio o aprovecha la ducha — sin prisa",
          "Ven con buena energía y respeto básico",
          "Cualquier cosa agresiva o fuera de límites termina la sesión",
          "Buscamos clientes de largo plazo, no caos rápido",
        ],
      },
      booking: {
        title: "Solicitar Sesión",
        subtitle: "Agenda Tu Experiencia",
        form: {
          name: "Nombre / Alias",
          contact: "Método de Contacto",
          phone: "Teléfono / WhatsApp",
          date: "Fecha y Hora Preferida",
          service: "Duración del Servicio",
          type: "Tipo de Sesión",
          notes: "Notas Adicionales",
          submit: "Enviar Solicitud",
          inCall: "En Casa",
          outCall: "A Domicilio",
        },
        success: {
          title: "¡Solicitud Enviada!",
          message: "Te contactaremos pronto para confirmar tu sesión.",
        },
      },
      faq: {
        title: "Preguntas Frecuentes",
        subtitle: "Dudas Comunes",
        items: [
          {
            question: "¿Cómo programo una sesión?",
            answer: "Contáctanos por llamada, mensaje, WhatsApp o email para discutir disponibilidad. Una vez confirmada la hora, proporcionaremos los detalles adicionales necesarios.",
          },
          {
            question: "¿Cómo se maneja el pago?",
            answer: "El pago por el tiempo reservado se acepta al inicio de cada sesión. Para citas a domicilio, puede requerirse un depósito para confirmar la programación.",
          },
          {
            question: "¿Puedo solicitar una compañera específica?",
            answer: "Sí, sujeto a disponibilidad. Contáctanos con tus preferencias y haremos lo posible por acomodar tu solicitud de programación.",
          },
          {
            question: "¿Cuál es la política de cancelación?",
            answer: "Por favor avisa con al menos 2 horas de anticipación para cualquier cambio de programación. Los depósitos para citas confirmadas no son reembolsables por ausencias o cancelaciones de último momento.",
          },
        ],
      },
      location: {
        title: "Área de Servicio",
        subtitle: "Dónde Estamos",
      },
      footer: {
        disclaimer: "Este sitio es solo para adultos de 18+ años. Al usar este sitio, confirmas que eres mayor de edad legal.",
        copyright: "Casa de Candy",
      },
    },
  },

  // SEO Configuration
  seo: {
    client: {
      title: "Casa de Candy | Premium Companionship Experience",
      description: "Exclusive companionship experiences with professionalism and discretion in the Rio Grande Valley.",
    },
    orientation: {
      title: "Join Casa de Candy | Brand Orientation",
      description: "Apply to join Casa de Candy. Professional opportunities for confident individuals.",
    },
    handbook: {
      title: "Casa de Candy | Employee Handbook",
      description: "Internal handbook and brand guidelines for Casa de Candy team members.",
    },
  },
};

export default siteConfig;
